import React from 'react';

export default function About() {
    
    return (
        <div className="container">
        <p class="about"> Hello! My name is Diago Montenegro, and I’m a Toronto-based web developer. Right now I’m a freelancer
            helping entrepeneurs with their websites and business needs all over the world.
            <br />
            <br />
            I have a diverse set of skills, ranging from simple designs and product pages to costumer databases.
            These skills have helped me develop websites for my clients that have helped their businesses succeed and
            boost business.
            <br />
            <br />
            Contact me today to start building something great!
        </p>
    
        
        </div>

    );
}
